import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { LicenseInfo } from '@mui/x-license';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { initializeSentry } from './globals/setUpSentry';
import { queryClient } from './setupTanstackQuery';

LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_X_LICENSE_KEY || '');

VSS.init({
  explicitNotifyLoaded: false,
  usePlatformScripts: false,
  usePlatformStyles: false,
});

// Register callback to get called when initial handshake completed
VSS.ready(function () {
  // Start using VSS
  initializeSentry();
  const rootElement = document.getElementById('root');
  if (rootElement) {
    createRoot(rootElement).render(
      <StrictMode>
        <QueryClientProvider client={queryClient}>
          <App />
          <ReactQueryDevtools />
        </QueryClientProvider>
      </StrictMode>
    );
  }
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
